<div class="d-flex mb-2 align-items-center">
  <span class="h1 m-0" data-test-id="resolved-findings-percentage">
    {{ 'percent_formatter' | translate: [progressPercentage.percentage] }}
  </span>
  @if (isPolicyViolated) {
    <ds-icon
      class="mx-2 my-1 policy-violated-icon"
      data-test-id="policy-violated-icon"
      tabindex="0"
      [icon]="Icons.Flag"
      [iconStyle]="IconStyles.Solid"
      [tooltipPlacement]="DsTooltipPosition.top"
      [ds-tooltip]="'policy_violated' | translate"
      [attr.aria-label]="'policy_violated' | translate"
    ></ds-icon>
  }
</div>

<div class="progress mt-2 mb-3" [style.height]="'1.5rem'">
  <div
    class="progress-bar"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [class.violated]="isPolicyViolated"
    [style.width]="progressPercentage.percentage + '%'"
    [attr.aria-label]="'resolved_findings_percentage' | translate"
    [attr.aria-valuenow]="progressPercentage.percentage"
  ></div>
</div>

<div data-test-id="resolved-findings-count">
  {{ 'resolved_findings_count' | translate: [formattedResolvedCount] }}
</div>

@if (progressPercentage.previousDate) {
  <div class="mt-2" data-test-id="resolved-findings-variation">
    @if (isPositiveVariation) {
      <ds-icon
        [icon]="Icons.ArrowTrendUp"
        [iconStyle]="IconStyles.Regular"
        [style.color]="EapColors.GreenSeverityLow"
        class="me-1"
      ></ds-icon>
    }
    @if (isNegativeVariation) {
      <ds-icon
        [icon]="Icons.ArrowTrendDown"
        [iconStyle]="IconStyles.Regular"
        [style.color]="EapColors.RedError"
        class="me-1"
      ></ds-icon>
    }
    <span aria-hidden="true">
      {{ 'resolved_findings_variation' | translate: [formattedVariation, progressPercentage.previousDate] }}
    </span>
    <span class="visuallyhidden" data-test-id="resolved-findings-variation-assistive-text">
      @if (isUnchangedVariation) {
        {{ 'resolved_findings_percentage_unchanged' | translate: [progressPercentage.previousDate] }}
      }
      @if (isPositiveVariation) {
        {{
          'resolved_findings_percentage_increase' | translate: [progressPercentage.absVariation, progressPercentage.previousDate]
        }}
      }
      @if (isNegativeVariation) {
        {{
          'resolved_findings_percentage_decrease' | translate: [progressPercentage.absVariation, progressPercentage.previousDate]
        }}
      }
    </span>
  </div>
}
